// extracted by mini-css-extract-plugin
module.exports = {"content":"Location_content__2CARQ","map":"Location_map__31pjT","details":"Location_details__2g-ZV","left":"Location_left__2xWqu","right":"Location_right__1y_SK"};